import React from "react";
import Stack from "../../../components/Stack/Stack";
import Calendar from "../../../components/Calendar/Calendar";

// Importamos el hook useNews
import { useNews } from "../../../hooks/useNews";

import image1 from "../../../assets/images/entitats/llogateres.jpg";
import image2 from "../../../assets/images/entitats/L_Espurna.jpg";
import image3 from "../../../assets/images/entitats/PAHC.jpg";
import image4 from "../../../assets/images/entitats/ArranCerdanyola.jpg";
import image5 from "../../../assets/images/entitats/GuanyemCerdanyola.png";

import "./HomeNews.css";

function HomeNews() {
  // Utilizamos el hook para obtener las noticias
  const { noticies, loadingNoticies, errorNoticies } = useNews();

  const images = [
    {
      id: 1,
      img: image1,
    },
    {
      id: 2,
      img: image2,
    },
    {
      id: 3,
      img: image3,
    },
    {
      id: 4,
      img: image4,
    },
    {
      id: 5,
      img: image5,
    },
  ];

  return (
    <section className="home-news">
      <div className="home-news__content">
        <div className="home-news__first-section">
          <div className="home-news__first-section__left">
            <h2 className="home-news__title">NOTÍCIES</h2>
            {loadingNoticies ? (
              <div className="loading-indicator">Carregant notícies...</div>
            ) : errorNoticies ? (
              <div className="error-message">
                Error al carregar les notícies: {errorNoticies.message}
              </div>
            ) : (
              <Stack
                randomRotation={true}
                sensitivity={180}
                sendToBackOnClick={false}
                cardDimensions={{ width: 360, height: 360 }}
                cardsData={noticies}
              />
            )}
          </div>
          <div className="home-news__first-section__right">
            <h2 className="home-news__title">CALENDARI</h2>
            <Calendar />
          </div>
        </div>
        <div className="home-news__second-section">
          <h2 className="home-news__title">ENTITATS</h2>
          <p>
            El casal és un espai on conflueixen moltes entitats del poble que
            creuen en l’organització popular com a forma de vida. Associacions
            culturals, col·lectius feministes, grups polítics i sindicals… el
            casal els ofereix un lloc de trobada per reunions i activitats, i
            un espai de confluència per coordinar-se i créixer dins del poble.
            Estem oberts a noves entitats que vulguin formar part de La Flama!
          </p>
          <div className="home-news__second-section__cards">
            {images.map((image) => (
              <div key={image.id} className="home-news__second-section__card">
                <img src={image.img} alt={`Entidad ${image.id}`} />
              </div>
            ))}
          </div>
          <a href="/entitats" className="home-news__entitats-link">
            VEURE MÉS
          </a>
        </div>
      </div>
    </section>
  );
}

export default HomeNews;
